<div class="customers">
    <div>
        <div class="card-body">
            <div class="row">
                <div class="separator" style="width: 100%;margin-left: 0px;margin-bottom: 10px;margin-right: -15px;">
                    <p class="estrategia-text"><strong>Estrategia: </strong> {{estrategiaData.estrategia}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p class="content" style="text-align: center;">ACCIONES</p>
                </div>
                <div class="col">
                    <p class="content" style="text-align: center;">MESES EN LOS QUE SERÁ MEDIDO</p>
                </div>
                <div class="col">
                    <p class="content" style="text-align: center;">MEDIOS DE VERIFICACIÓN</p>
                </div>
            </div>
            <div class="row">
                <div *ngFor="let accionData of estrategiaData.acciones; let indice=index; ">
                    <app-accion-anual [accionData]="accionData" [readonly]="readonly"></app-accion-anual>
                </div>
            </div>
        </div>
    </div>
</div>